export enum Delimiters {
    COLON = ':',
    DASH = '-',
    SLASH = '/',
    DOT = '.',
    COMMA = ',',
    SEMICOLON = ';',
    PIPE = '|',
    UNDERSCORE = '_',
    TILDE = '~',
    ASTERISK = '*',
    QUESTION_MARK = '?',
    EXCLAMATION_MARK = '!',
    PLUS_SIGN = '+',
    ARROW = '->',
    ARROW_WITH_SPACES = ` ${ARROW} `,
}
